import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.warehouses || initialState;

const makeSelectList = () =>
  createSelector(select, subState => subState.warehousesList);

const makeSelectChildrenList = () =>
  createSelector(select, subState => subState.warehousesChildrenList);

const makeSelectWarehousesInventoryList = () =>
  createSelector(select, subState => subState.warehousesInventoryList);

const makeSelectWarehousesInventoryCount = () =>
  createSelector(select, subState => subState.warehousesInventoryListCount);

const makeSelectWarehouseOperatorsList = () =>
  createSelector(select, subState => subState.warehouseOperators);

const makeSelectWarehouseOperatorsCount = () =>
  createSelector(select, subState => subState.warehouseOperatorsCount);

const makeSelectSkusInventoryList = () =>
  createSelector(select, subState => subState.skusInventorylist);

const makeSelectSkusInventory = () =>
  createSelector(select, subState => subState.skuInventory);

const makeSelectAvailableCount = () =>
  createSelector(select, subState => subState.availableCount);

const makeSelectOnWayCount = () =>
  createSelector(select, subState => subState.onWayCount);

const makeSelectReturnedCount = () =>
  createSelector(select, subState => subState.returnedCount);

const makeSelectSkusInventoryCount = () =>
  createSelector(select, subState => subState.skuInventoryCount);

const makeSelectSkusInventoryListCount = () =>
  createSelector(select, subState => subState.skusInventorylistCount);

const makeSelectWarehouseInventory = () =>
  createSelector(select, subState => subState.warehouseInventory);

const makeSelectWarehouseInventoryCount = () =>
  createSelector(select, subState => subState.warehouseInventoryCount);

const makeSelectInventoryItems = () =>
  createSelector(select, subState => subState.inventoryItemsList);

const makeSelectInventoryItemsWithSerial = () =>
  createSelector(select, subState => subState.inventoryItemsWithSerialList);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

const makeSelectWarehouse = () =>
  createSelector(select, subState => subState.warehouse);

const makeSelectParcelsItems = () =>
  createSelector(select, subState => subState.parcelsItems);

export default select;
export {
  makeSelectList,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectWarehousesInventoryList,
  makeSelectInventoryItems,
  makeSelectWarehouse,
  makeSelectChildrenList,
  makeSelectSkusInventoryList,
  makeSelectWarehouseInventory,
  makeSelectParcelsItems,
  makeSelectSkusInventory,
  makeSelectWarehousesInventoryCount,
  makeSelectSkusInventoryListCount,
  makeSelectSkusInventoryCount,
  makeSelectWarehouseInventoryCount,
  makeSelectAvailableCount,
  makeSelectOnWayCount,
  makeSelectReturnedCount,
  makeSelectWarehouseOperatorsList,
  makeSelectWarehouseOperatorsCount,
  makeSelectInventoryItemsWithSerial,
};
